import type { User } from './stores/auth';

/** 用户是否有 Staff 身份（adminStaff 表 active 记录） */
export function isStaff(user: User | null | undefined): boolean {
  return !!user?.staff;
}

/** Staff 是否被授予某动作（staffActionGrants） */
export function hasStaffAction(user: User | null | undefined, action: string): boolean {
  return user?.staff?.actions.includes(action) ?? false;
}

/** 能否访问某 Admin 模块：admin 全权限；staff 按授权动作判断 */
export function canAccessModule(user: User | null | undefined, action: string): boolean {
  if (!user) return false;
  return user.role === 'admin' || hasStaffAction(user, action);
}
